export default "/images/Vector-1.svg?dadb3bf607cc7757f1564df37775296b";